import{a as m}from"./chunk-ATTWGF2B.js";import{a as n}from"./chunk-R4CJRRE3.js";import{a as r,m as e}from"./chunk-HBP5N4FR.js";e();import p from"react";var d=o=>{let t=n(o.toastId);return p.createElement(m,r({},o),t&&p.createElement(t,null))};export{d as a};
//# sourceMappingURL=chunk-FL246QN7.js.map
